//@ts-check
import React from 'react';
import Error from './Error';
import Loader from './Loader';
import JobDetails from './Job';
import withAuth from '../../../../core/EcrionProvider/boot/withAuth';
import DataItem from '../../../../data/Item';
import Utils from '../../../../utils';
/**
 * @param {import('../types').JobLoaderProps} props
 */

var JobLoader = function JobLoader(props) {
  var setAuth = props.setAuth,
      auth = props.auth,
      token = props.token;
  React.useEffect(function () {
    if (token) setAuth({
      token: token
    });
    return function () {
      setAuth({
        token: auth.token
      });
    };
  }, [token]);
  if (token && auth.token !== token) return React.createElement(Loader, null);
  var jobId = props.jobId,
      workspace = props.workspace,
      projectId = props.projectId,
      projectName = props.projectName;
  var toolbar = props.toolbar,
      showToolbar = props.showToolbar;
  var dataType = projectId ? 'project' : 'projectName';
  var dataId = projectId ? projectId : projectName;
  return React.createElement(DataItem, {
    dataType: dataType,
    id: dataId
  }, function (_ref) {
    var loading = _ref.loading,
        error = _ref.error,
        project = _ref.value;
    if (loading) return React.createElement(Loader, null);
    if (error) return React.createElement(Error, null, "We encounter an error: ", Utils.getPrettyError(error));
    return React.createElement(DataItem, {
      dataType: "communicationRun",
      id: jobId,
      dataProps: {
        workspace: workspace
      }
    }, function (_ref2) {
      var loading = _ref2.loading,
          error = _ref2.error,
          value = _ref2.value,
          actions = _ref2.actions;
      if (loading) return React.createElement(Loader, null);
      if (error) return React.createElement(Error, null, "We encounter an error: ", Utils.getPrettyError(error));

      var onJobUpdated = function onJobUpdated() {
        actions.fetch();
      };

      return React.createElement(JobDetails, {
        job: value,
        workspace: workspace,
        project: project,
        onJobUpdated: onJobUpdated,
        toolbar: toolbar || showToolbar && {
          title: value && value.JobName
        }
      });
    });
  });
};

export default withAuth(JobLoader);